// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z2VWJ","top":"styles_top__S7VJS","left":"styles_left__1js3v","description":"styles_description__3EqcS"};